import {useSelector} from 'react-redux';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {AutoDeliveryFrequency} from '@/consts/icc/iccAutoDeliveryStatusTypes';
import {selectLanguageCode} from '@/state/selectors/global';
import {twx} from '@/utils/tailwindUtils';

import {getFrequencyLabel} from '../frequencyContentMapper';
import {getRescheduleContent} from '../utils/getRescheduleContent';
import {getRescheduleDateLabel} from '../utils/rescheduleDateLabel';

type RescheduleSelectionSummaryCardProps = {
    selectedFrequency: AutoDeliveryFrequency | null;
    minDate: Date;
    maxDate: Date;
    className?: string;
};

const RescheduleSelectionSummaryCard = ({
    selectedFrequency,
    minDate,
    maxDate,
    className,
}: RescheduleSelectionSummaryCardProps) => {
    const languageCode = useSelector(selectLanguageCode);
    const rescheduleDeliveryContent = getRescheduleContent();
    const {
        deliveryFrequencyIcon,
        nextDeliveryDateIcon,
        deliveryFrequencyLabel,
        nextDeliveryDateLabel,
        dateDayPluralForms,
        nextDeliveryDateFormatSameMonth,
        nextDeliveryDateFormatCrossMonth,
        nextDeliveryDateFormatCrossYear,
        selectFrequencyContent,
    } = rescheduleDeliveryContent || {};
    const selectedFrequencyLabel = selectedFrequency && getFrequencyLabel(selectFrequencyContent, selectedFrequency);
    const formattedDate = getRescheduleDateLabel({
        minDate,
        maxDate,
        languageCode,
        dateDayPluralForms,
        nextDeliveryDateFormatSameMonth,
        nextDeliveryDateFormatCrossMonth,
        nextDeliveryDateFormatCrossYear,
    });

    return (
        <div
            className={twx(
                'leading-20 flex w-full flex-col gap-4 rounded-xl bg-primary-dark-5 p-4 text-start',
                className
            )}
        >
            {selectedFrequency && (
                <div className='flex items-center gap-2'>
                    {deliveryFrequencyIcon && (
                        <RemoteIconV2 icon={deliveryFrequencyIcon} className='size-12 shrink-0' />
                    )}
                    <div>
                        <p>{deliveryFrequencyLabel}</p>
                        <p className='font-bold'>{selectedFrequencyLabel}</p>
                    </div>
                </div>
            )}
            <div className='flex items-center gap-2'>
                {nextDeliveryDateIcon && <RemoteIconV2 icon={nextDeliveryDateIcon} className='size-12 shrink-0' />}
                <div>
                    <p>{nextDeliveryDateLabel}</p>
                    <p className='font-bold'>{formattedDate}</p>
                </div>
            </div>
        </div>
    );
};

export default RescheduleSelectionSummaryCard;
